import React from 'react';

const STOP_PROPAGATION = e => e.stopPropagation();

export default function a(props) {
	return <a onClick={STOP_PROPAGATION} {...props} />;
}
